// M4 · VIP, simulated (QM4_Core; file name kept from "Core"): the buddy's limit line (only when today's free messages
// are really used up), the perks, "Start VIP · simulated" (POST /api/vip { on: true }), the done state.
import { C } from '@shared/content/characters';
import { LINES } from '@shared/content/lines';
import { useApp, setVip } from '../../store';
import { back, go } from '../../router';
import { Screen, ScrollArea, XScene, IconButton, PrimaryButton, TextButton, Icon } from '../../components';
import { ME } from './copy';
import s from './me.module.css';
import { say } from '../../lib/say';

export function VipScreen() {
  const st = useApp((x) => x.state);
  if (!st) return <Screen theme="margo" id="M4" />;
  const ch = st.ch, c = C[ch], vip = st.user.vip, u = st.usage;
  const atLimit = !vip && u.messagesToday >= u.freeLimit;

  return (
    <Screen theme={ch} id="M4">
      <XScene ch={ch} stage={st.buddy.stage} mode="dim" alt="" />
      <div class={s.vipTop}>
        <IconButton icon="back" label="Back" onClick={() => back('M1')} />
        <span class={s.count}>{vip ? 'VIP · unlimited today' : `${Math.min(u.messagesToday, u.freeLimit)} of ${u.freeLimit} free messages today`}</span>
      </div>
      {atLimit && (
        <div class={s.say}>
          <p class={s.sayName}>{c.name}</p>
          <p class={s.sayLine}>{say(LINES[ch].vipLine, { n: C[ch].name })}</p>
        </div>
      )}
      <section class={s.panel} aria-label="VIP">
        <ScrollArea fadeTop={16} fadeBottom={16}>
          <div class={s.panelIn}>
            {!vip ? (
              <>
                <div class={s.vipHead}>
                  <h1 class={s.vipH1}>VIP</h1>
                  <p class={s.price}>{ME.price}</p>
                </div>
                <div class={s.perks}>
                  {ME.perks(c.name).map((p) => (
                    <div class={s.perk} key={p.title} data-muted={'muted' in p ? 'true' : 'false'}>
                      <span class={s.perkIcon} aria-hidden="true"><Icon name={p.icon} size={20} strokeWidth={1.8} /></span>
                      <div class={s.two} style={{ flex: 1 }}>
                        <p class={s.perkT}>{p.title}</p>
                        {p.sub && <p class={s.perkS}>{p.sub}</p>}
                      </div>
                    </div>
                  ))}
                </div>
                <PrimaryButton h={56} data-cta="vip" onClick={() => void setVip(true)}>Start VIP · simulated</PrimaryButton>
                <TextButton weight={600} onClick={() => back('M1')}>Not now</TextButton>
              </>
            ) : (
              <>
                <div class={s.bought}>
                  <span class={s.okDot} aria-hidden="true"><Icon name="check" size={32} strokeWidth={2.6} /></span>
                  <p class={s.boughtT}>{ME.vipOn}</p>
                  <p class={s.small} style={{ fontSize: 15 }}>{ME.charged}</p>
                </div>
                <PrimaryButton h={56} data-cta="back" onClick={() => go('C')}>{`Back to ${c.name}`}</PrimaryButton>
                <TextButton weight={600} onClick={() => void setVip(false)}>{ME.vipOff}</TextButton>
              </>
            )}
            <p class={s.sim}>{ME.simulated}</p>
          </div>
        </ScrollArea>
      </section>
    </Screen>
  );
}
